import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import accounting from 'accounting';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  props: {
    modelValue: {
      required: true
    },
    decimals: {
      required: true,
      type: Number
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var input = ref(null);

    var asNumber = function asNumber(val) {
      return accounting.unformat(val, isNaN(Number(val)) ? ',' : '.');
    };

    var formatNumber = function formatNumber(val) {
      val = asNumber(val);
      return accounting.formatNumber(val, {
        precision: props.decimals,
        thousand: '.',
        decimal: ','
      });
    };

    var formattedValue = function formattedValue(val) {
      if (!val && val !== 0) {
        return null;
      }

      return formatNumber(val);
    };

    var onBlur = function onBlur(val) {
      var num = null;

      if (val !== '') {
        input.value.value = formatNumber(val);
        num = asNumber(val);
        num = Number(accounting.toFixed(num, props.decimals));
      }

      emit('update:modelValue', num);
    };

    var onFocus = function onFocus(e) {
      var val = e.target.value.toString();
      e.target.value = val.replace(/\./g, '');
      e.target.select();
    };

    return {
      onBlur: onBlur,
      formattedValue: formattedValue,
      input: input,
      onFocus: onFocus
    };
  }
});